import { Controller } from '@hotwired/stimulus'

// Class candidates for the dynamic placement classes, so that tailwind generates them:
// tooltip-right tooltip-left tooltip-bottom tooltip-top
const FADE_TIMEOUT = 300

export default class extends Controller {
  static values = { content: String, placement: { type: String, default: 'right' } }

  connect () {
    this.hideOnScroll = () => this.hide()
    window.addEventListener('scroll', this.hideOnScroll, true)
    window.addEventListener('resize', this.hideOnScroll)
  }

  disconnect () {
    window.removeEventListener('scroll', this.hideOnScroll, true)
    window.removeEventListener('resize', this.hideOnScroll)
    this.hide()
  }

  show () {
    if (!this.contentValue) return

    this.hide()

    this.portal = document.createElement('div')
    this.portal.id = `tooltip-${crypto.randomUUID?.() ?? Math.random().toString(36).slice(2)}`
    this.portal.setAttribute('role', 'tooltip')
    this.portal.className = `tooltip tooltip-${this.placementValue} fixed z-[9999]`
    this.portal.dataset.tip = this.contentValue
    document.body.appendChild(this.portal)
    this.element.setAttribute('aria-describedby', this.portal.id)

    const rect = this.element.getBoundingClientRect()
    let pointX
    let pointY
    if (this.placementValue === 'top' || this.placementValue === 'bottom') {
      pointX = rect.left + (rect.width / 2)
      pointY = this.placementValue === 'top' ? rect.top : rect.bottom
    } else {
      pointX = this.placementValue === 'left' ? rect.left : rect.right
      pointY = rect.top + (rect.height / 2)
    }
    this.portal.style.left = `${pointX}px`
    this.portal.style.top = `${pointY}px`

    this.forceReflow()
    this.portal.classList.add('tooltip-open')
  }

  hide () {
    clearTimeout(this.fadeTimeout)

    const portal = this.portal
    this.portal = null
    if (portal == null) return

    this.element.removeAttribute('aria-describedby')
    portal.classList.remove('tooltip-open')
    portal.addEventListener('transitionend', () => portal.remove(), { once: true })
    this.fadeTimeout = setTimeout(() => portal.remove(), FADE_TIMEOUT)
  }

  forceReflow () {
    // read the layout so the initial hidden tooltip state is committed before fading in
    return this.portal.offsetHeight
  }
}
